import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';

const PaymentsForm = ({ formInput }) => {
  const content = JSON.stringify(formInput, null, 2);
  return (
    <Fragment>
      <div className="bg-black text-white p-4">
        <pre>
          {content}
        </pre>
      </div>
    </Fragment>
  );
};

PaymentsForm.propTypes = {
  formInput: PropTypes.arrayOf(PropTypes.shape()),
};

PaymentsForm.defaultProps = {
  formInput: [],
};

export default PaymentsForm;
